export const IS_SSR = typeof window === 'undefined'

export const defaultDateFormat = 'dd/MM/yyyy'
